/**
 * Temporary instrumentation: logs heavy dashboard-bound API calls before they fire.
 * Enable: dev server by default; or production build via VITE_DASHBOARD_HEAVY_API_TRACE=1.
 */

function _dashboardHeavyApiTraceEnabled() {
  try {
    if (typeof import.meta !== "undefined" && import.meta.env) {
      if (import.meta.env.DEV === true) return true;
      if (
        String(import.meta.env?.VITE_DASHBOARD_HEAVY_API_TRACE || "").trim() ===
        "1"
      )
        return true;
    }
  } catch {
    // ignore
  }
  return false;
}

/**
 * @param {{ endpoint: string, component?: string, reason?: string }} p
 */
export function traceDashboardHeavyApiCall({
  endpoint,
  component = "fhpService",
  reason = "",
} = {}) {
  if (!_dashboardHeavyApiTraceEnabled()) return;
  try {
    const pathname =
      typeof window !== "undefined" &&
      window.location != null &&
      typeof window.location.pathname === "string"
        ? window.location.pathname
        : "";
    console.log("[DASHBOARD_HEAVY_API_CALL_TRACE]", {
      endpoint: endpoint ?? "",
      component,
      "location.pathname": pathname,
      reason: reason ?? "",
      timestamp: new Date().toISOString(),
    });
  } catch {
    // Never affect API flows
  }
}
